import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Link } from '@mui/material';
import { LoginCredentials } from '../../types/auth';

interface LoginFormProps {
    onSubmit: (credentials: LoginCredentials) => void;
    onToggleForm: () => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, onToggleForm }) => {
    const [credentials, setCredentials] = useState<LoginCredentials>({
        email: '',
        password: '',
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log('Form submitted');
        onSubmit(credentials);
    };

    const handleButtonClick = () => {
        console.log('Button clicked');
        onSubmit(credentials);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                Sign In
            </Typography>
            <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            />
            <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleButtonClick}
            >
                Sign In
            </Button>
            <Link
                component="span"
                variant="body2"
                onClick={(e) => {
                    e.preventDefault();
                    onToggleForm();
                }}
                sx={{ cursor: 'pointer', display: 'inline-block' }}
            >
                Don't have an account? Sign Up
            </Link>
        </Box>
    );
};
